<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-21 14:06:13
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-26 16:25:40
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/supplyServiceCapability.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 供应商信息以及资质信息 -->
<template>
  <div class="supplier-info-wrapper">
    <!--        <div class="supplier-info-title">供应商信息</div>-->
    <div class="supplier-info-tip margin-b20">
      三证信息将作为产品质量评价的重要依据，信息维护请前往
      <span style="color: #0064c8;cursor:pointer" @click="toPath('basic')">会员中心-公司信息-基本信息</span>
    </div>

    <div class="border-wrapper margin-b20">
      <el-row>
        <el-col :span="12">
          <span class="e-descriptions-item-label">供应商名称：</span>
          <span class="e-descriptions-item-content">{{
            applyInfo.companyName
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="e-descriptions-item-label">供应商类型：</span>
          <span class="e-descriptions-item-content">{{
            applyInfo.supplierTypeDesc
          }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span class="e-descriptions-item-label">公司名称：</span>
          <span class="e-descriptions-item-content">{{
            detailData.companyName
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="e-descriptions-item-label">公司注册地址：</span>
          <span class="e-descriptions-item-content">{{
            detailData.regCity
          }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span class="e-descriptions-item-label">营业执照注册号：</span>
          <span class="e-descriptions-item-content">{{
            detailData.businessLicenseNo
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="e-descriptions-item-label">有效期至：</span>
          <span class="e-descriptions-item-content">{{
            detailData.longTernEffectiveBNo
              ? '长期有效'
              : detailData.certificateValidityEndBNo
          }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span class="e-descriptions-item-label">税务登记号：</span>
          <span class="e-descriptions-item-content">{{
            detailData.taxId
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="e-descriptions-item-label">有效期至：</span>
          <span class="e-descriptions-item-content">{{
            detailData.longTernEffectiveTaxId
              ? '长期有效'
              : detailData.certificateValidityEndTaxId
          }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span class="e-descriptions-item-label">组织机构代码：</span>
          <span class="e-descriptions-item-content">{{
            detailData.organizationCode
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="e-descriptions-item-label">有效期至：</span>
          <span class="e-descriptions-item-content">{{
            detailData.longTernEffectiveOCode
              ? '长期有效'
              : detailData.certificateValidityEndOCode
          }}</span>
        </el-col>
      </el-row>
    </div>

    <div class="supplier-info-title">资质信息</div>

    <div class="supplier-info-tip margin-b20">
      资质信息将作为产品质量评价的重要依据（请关注《产品质量评价办法》中有关资质要求)，信息维护请前往
      <span style="color: #0064c8;cursor:pointer" @click="toPath('qualificationInformation')">运营中心-基本信息设置-资质信息</span>
    </div>

    <div class="supplier-info-little-title margin-b10">通用资质</div>
    <e-table-list
      class="margin-b20"
      :loading="false"
      rowKey="businessConsultEmail"
      :table-data="generalQualifications"
      :table-label="commonLabel"
    >
      <template v-slot:operate="slot">
        <eui-btn
          type="text"
          @click="handleView(slot.scope.row.certRelativePathUrl)"
          font-size="12px"
          >查看</eui-btn
        >
      </template>
    </e-table-list>

    <div class="supplier-info-little-title margin-b10">认证资质</div>
    <e-table-list
      class="margin-b20"
      :loading="false"
      rowKey="businessConsultEmail"
      :table-data="certificationQualifications"
      :table-label="commonLabel"
    >
      <template v-slot:operate="slot">
        <eui-btn
          type="text"
          @click="handleView(slot.scope.row.certRelativePathUrl)"
          font-size="12px"
          >查看</eui-btn
        >
      </template>
    </e-table-list>

    <div class="supplier-info-little-title margin-b10">证明资质</div>
    <div class="border-wrapper margin-b20">
      <e-table-list
        :loading="false"
        rowKey="businessConsultEmail"
        :table-data="proveQualifications"
        :table-label="commonLabel"
      >
        <template v-slot:operate="slot">
          <eui-btn
            type="text"
            @click="handleView(slot.scope.row.certRelativePathUrl)"
            font-size="12px"
            >查看</eui-btn
          >
        </template>
      </e-table-list>
    </div>

    <div class="form-title margin-b10">供应服务能力</div>

    <div class="supplier-info-tip margin-b20">
      供应服务能力信息将作为产品质量评价的重要依据，信息维护请前往
      <span style="color: #0064c8;cursor:pointer" @click="toPath('supplyServiceCapabilityInfo')">运营中心-基本信息设置-供应服务能力信息</span>
    </div>

    <e-table-list
      class="margin-b20"
      :loading="false"
      rowKey="businessConsultEmail"
      :table-data="serviceAbility"
      :table-label="serviceAbilityLabel"
    >
      <template v-slot:operate="slot">
        <eui-btn
          type="text"
          @click="handleView(slot.scope.row.infoRelativePathUrl)"
          font-size="12px"
          >查看</eui-btn
        >
      </template>
    </e-table-list>

    <div class="check-box" v-if="applyStatus === '218'">
      <el-checkbox v-model="isChecked" @change="handleConfirm"
        >我确认以上提供的资质信息和供应服务能力信息真实、准确、完整、有效。申请进入审核流程后，不允许修改此申请中所提交信息，
        请确认之后再提交。</el-checkbox
      >
    </div>
  </div>
</template>

<script>
import eTableList from '../../../../components/common/e-table-list';
import api from '@/modules/projectA/api/ESorganization/index';
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import {epecMallUrl} from '../../../../api/config';
export default {
  data() {
    return {
      isChecked: false,
      generalQualifications: [], //通用资质
      commonLabel: [
        { label: '证书类型', param: 'certName', align: 'center' },
        { label: '证书编号', param: 'certNo', align: 'center' },
        { label: '有效期结束时间', param: 'certExpireDate', align: 'center' },
        { label: '状态', param: 'certStatus', align: 'center' },
        { label: '更新时间', param: 'certUpdateDate', align: 'center' },
        { label: '操作', param: '', align: 'center', slot: 'operate' },
      ],
      certificationQualifications: [], //认证资质
      proveQualifications: [], //证明资质
      serviceAbility: [], //供应商服务能力
      serviceAbilityLabel: [
        { label: '信息类型', param: 'infoType', align: 'center' },
        { label: '信息名称', param: 'infoName', align: 'center' },
        { label: '更新日期', param: 'infoUpdateDate', align: 'center' },
        { label: '状态', param: 'infoStatusDesc', align: 'center' },
        { label: '操作', param: '', align: 'center', slot: 'operate' },
      ],
      detailData: {},
      qualificationService: {},
      applyStatus:'',
    };
  },
  props: {
    applyInfo: Object,
  },
  components: { EuiBtn, eTableList },
  computed: {},
  methods: {
    toPath(type){
      if(type === 'basic'){
        window.open(`${epecMallUrl}/user/user/companyInfo`, '_blank')
      }else if(type === 'supplyServiceCapabilityInfo'){
        this.$router.push({ path: "/supplyServiceCapabilityInfo" });
      }else if(type === 'qualificationInformation'){
        this.$router.push({ path: "/qualificationInformation" });
      }
    },
    async handleView(path) {
      let res = await api.getGSNAbsolutePathUrl({gsnRelativePathUrl: path});
      // gsnFileType文件类型  1:图片 2:文件
      if (res.success) {
        window.open(res.data.gsnAbsolutePathUrl, '_blank');
      }
    },
    //查询供应商信息
    async getEvaluationApplySupplierDetail() {
      let res = await api.getEvaluationApplySupplierDetail({
        applyId: this.applyInfo.applyId,
      });
      if (res.success) {
        this.detailData = res.data.companyVO;
      }
    },
    //资质信息，供应服务能力
    async getEvaluationApplyStandardizedQualificationDetail() {
      let res = await api.getEvaluationApplyStandardizedQualificationDetail({
        applyId: this.applyInfo.applyId,
      });
      if (res.success) {
        let zzxx = res.data.standardizedQualificationVOList.filter(
          (item) => Number(item.moduleType) === 1
        );
        let qualificationVOList = zzxx[0].qualificationVOList ? zzxx[0].qualificationVOList : [];

        //通用资质
        let tyzz = qualificationVOList.filter(
          (item) => Number(item.qualificationCode) === 20
        ) || [];

        if(tyzz.length > 0){
          this.generalQualifications = tyzz[0].certVOList;
        }

        //认证资质
        let rzzz = qualificationVOList.filter(
          (item) => Number(item.qualificationCode) === 22
        ) || [];

        if(rzzz.length > 0){
          this.certificationQualifications = rzzz[0].certVOList;
        }

        //证明资质
        let zmzz = qualificationVOList.filter(
          (item) => Number(item.qualificationCode) === 23
        ) || [];
        if(zmzz.length > 0){
          this.proveQualifications = zmzz[0].certVOList;
        }

        //供应商服务能力
        let gyfwnl = res.data.standardizedQualificationVOList.filter(
          (item) => Number(item.moduleType) === 2
        ) || [];
       if(gyfwnl.length > 0){
         this.serviceAbility = gyfwnl[0].infoVOList;
       }

      }
    },
    handleConfirm() {
      this.$emit('changeConfirm', this.isChecked);
    },
  },
  watch: {
    applyInfo: {
      immediate:true,
      deep:true,
       handler (val) {
        if(val){
          this.getEvaluationApplySupplierDetail(); //查询供应商信息
          this.getEvaluationApplyStandardizedQualificationDetail(); //资质信息，供应服务能力
        }

      }
    },
  },
  mounted() {
    this.applyStatus = String(this.$route.query.applyStatus);
  }
};
</script>
<style lang="scss" scoped>
.supplier-info-wrapper {
  .supplier-info-title {
    color: #333;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .supplier-info-little-title {
    font-size: 14px;
    color: #333333;
  }
  .supplier-info-tip {
    padding-left: 10px;
    height: 44px;
    line-height: 44px;
    background-color: #f4f7ff;
    color: #666;
    font-size: 14px;
  }
}
.check-box {
  color: #333;
  font-weight: 500;
}
.border-wrapper {
  padding-bottom: 20px;
  border-bottom: 1px dashed #c5c5c5;
}
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
  &.color-red {
    color: #e50113;
  }
}
.e-descriptions-item-label {
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
</style>
